export const testReportMapper = (workspaceId: string, name: string, date: Date, data: any, user: string) => {
  return {
    workspaceId: workspaceId,
    workspaceName: name,
    createdAt: date,
    metadata: data,
    user: user
  };
};
